module.exports = {
    /* color */
    '--im-brand-color': '#3478F6',
    '--im-toast-color':'#F95051',
    '--im-bg1-color':'#F8F8F9',
    '--im-bg2-color':'#F6F6F6',
    '--im-bg3-color':'#FFFFFF',
    '--im-selected-color':'#EAEAEA',
    '--im-ses-top-color' : '#F6F7F7',

     /* fontsize */
     '--im-fontsize-46':'46rpx',
     '--im-fontsize-38':'38rpx',
     '--im-fontsize-36':'36rpx',
     '--im-fontsize-34':'34rpx',
     '--im-fontsize-32':'32rpx',
     '--im-fontsize-30':'30rpx',
     '--im-fontsize-28':'28rpx',
     '--im-fontsize-26':'26rpx',
     '--im-fontsize-24':'24rpx',
     '--im-fontsize-22':'22rpx',
     '--im-fontsize-20':'20rpx',

     /* color */

     '--im-fontcolor-1': '#333333',
     '--im-fontcolor-2': '#999999',
     '--im-fontcolor-3': '#AAAAAA',
     '--im-fontcolor-4': '#8D92AF',
     '--im-fontcolor-5': '#FFFFFF',

      /* border-radius */
      '--im-border-radius-card-1':'24rpx',
      '--im-border-radius-2':'6rpx',
      '--im-border-radius-3':'12rpx',
      '--im-border-radius-toast-4':'24rpx',

      /* padding */
      '--im-page-padding':'24rpx',
      '--im-card-top-bottom-padding':'6rpx',
      '--im-card-left-right-padding':'12rpx',
}
